import React from 'react';
import { Button, Modal } from 'reactstrap';
import SpinnerCircles from './Spinner/SpinerCircles';

const headLabel = 'Out of band management';
const obWarningText = `Out of Band Management is a Paid Add-On. Each endpoint will require a Billing Telephone Number (BTN). These endpoints are billed at standard contracted rates for DID’s.`;
const confirmation = 'Are you sure you want to proceed?'

const BandManagementWarningModal = ({ isOpen, goHandler, cancelHandler, loading }) => (
  <Modal isOpen={isOpen} style={{ width: '50%', }}>
    <div className="band-management-warning-container">
      <label className='modal-clr-heading'>{headLabel}</label>
      {loading ?
        <SpinnerCircles red /> 
        :
        <>
          <h1>{obWarningText}</h1>
          <h1>{confirmation}</h1>
          <div className='management-modal-btn-section mt-2 justify-content-end' >
            <Button outline onClick={cancelHandler}> Cancel </Button>
            <Button color="primary" disabled={loading} onClick={goHandler} className='ml-2' id="oobm_go_btn">
              Go
            </Button>
          </div>
        </>
      }

    </div>
  </Modal>
);

export default BandManagementWarningModal;
